// 负责订单创建纯函数，与购物车、支付 Provider 和后续订单落库关联。
import type { CartLine } from "../cart";
import type { CustomerDetails, Order } from "./types";

export type CreateOrderInput = {
  lines: CartLine[];
  customer: CustomerDetails;
  shipping: number;
  createId: () => string;
  now: () => string;
};

// 校验客户信息，避免创建缺少联系上下文的订单。
const assertCustomerDetails = (customer: CustomerDetails) => {
  if (!customer.email.trim() || !customer.email.includes("@")) {
    throw new Error("Customer email is required before creating an order.");
  }

  if (!customer.country.trim()) {
    throw new Error("Customer country is required before creating an order.");
  }
};

// 从购物车行项目创建待支付订单。
export const createOrder = ({
  lines,
  customer,
  shipping,
  createId,
  now
}: CreateOrderInput): Order => {
  if (lines.length === 0) {
    throw new Error("Cart must contain at least one item before checkout.");
  }

  assertCustomerDetails(customer);

  const orderLines = lines.map((line) => ({
    productId: line.productId,
    name: line.product.name,
    size: line.size,
    quantity: line.quantity,
    unitPrice: line.product.price,
    lineTotal: line.lineTotal
  }));
  const subtotal = orderLines.reduce((total, line) => total + line.lineTotal, 0);
  const createdAt = now();

  return {
    id: createId(),
    lines: orderLines,
    totals: {
      subtotal,
      shipping,
      total: subtotal + shipping,
      currency: "USD"
    },
    customer: {
      email: customer.email.trim(),
      country: customer.country.trim()
    },
    paymentStatus: "pending",
    fulfillmentStatus: "unfulfilled",
    paymentEventIds: [],
    createdAt,
    updatedAt: createdAt
  };
};
